import React from "react"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

const NumbersImageBlock = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="true"
      className=""
    >
      <div className="mt-8">
        <Richtext text={block.text} />
        <div className="flex flex-row flex-wrap mt-8 -mx-grid">
          <div className="w-full px-grid md:w-2/5 md:order-last">
            <Image
              className="w-full h-auto mb-8 rounded-xl"
              image={block.image}
              aspectRatio={block.aspect_ratio}
            />
          </div>
          <div className="w-full px-grid md:w-3/5">
            <div className="flex flex-row flex-wrap -mx-grid">
              {block.number_items?.length > 0 &&
                block.number_items.map((item, index) => (
                  <div key={index} className="w-full md:w-1/2 px-grid">
                    <Link
                      link={item.link}
                      className="block p-4 mb-8 text-center group rounded-xl hover-shadow"
                    >
                      <span className="block text-3xl font-semibold text-accent group-hover:text-accent-hover">
                        {item.number}
                      </span>
                      <span className="font-semibold">{item.title}</span>
                      <p className="prose text-gray-500">{item.text}</p>
                    </Link>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </BlockWrapper>
  )
}

export default NumbersImageBlock
